import React from "react";

import { IgCheckbox, IgRadio, IgTypography } from "@intelligems/ig-theme";
import {
  MessageBoxWidgetDto,
  ProgressBarWidgetDto,
  QuantityButtonsWidgetDto,
  WidgetType,
} from "@intelligems/ig-types";
import { FormControlLabel, Grid, RadioGroup } from "@mui/material";
import { isProgressBar } from "@src/store/slices/widgets/util";

interface LayoutSectionProps {
  widgetType: WidgetType;
  layout: string | boolean;
  onLayoutChange: (layout: string | boolean) => void;
  widget: ProgressBarWidgetDto | QuantityButtonsWidgetDto | MessageBoxWidgetDto;
  disabled?: boolean;
}

export const LayoutSection = ({
  widgetType,
  layout,
  onLayoutChange,
  widget,
  disabled,
}: LayoutSectionProps) => {
  const isProgressBarWidget = isProgressBar(widget);
  const getLayoutOptions = () => {
    if (widgetType === "quantityButtons") {
      return [
        { value: "row", label: "Side-by-side" },
        { value: "column", label: "Stacked" },
      ];
    }
    return [
      { value: "horizontal", label: "Horizontal" },
      { value: "vertical", label: "Vertical" },
    ];
  };

  return (
    <Grid item container direction="column" spacing={3}>
      <Grid item>
        <IgTypography fontWeight="600" variant={"body1"}>
          Layout
        </IgTypography>
      </Grid>
      <Grid item>
        {isProgressBarWidget ? (
          <FormControlLabel
            disabled={disabled}
            control={
              <IgCheckbox
                disabled={disabled}
                checked={Boolean(layout)}
                onChange={(e) => onLayoutChange(e.target.checked)}
                size="small"
              />
            }
            label={
              <IgTypography variant={"body1"}>
                Swap dynamic progress and breakpoint text positions
              </IgTypography>
            }
          />
        ) : (
          <RadioGroup
            value={String(layout)}
            onChange={(e) => onLayoutChange(e.target.value)}
            row
          >
            {getLayoutOptions().map((option) => (
              <FormControlLabel
                disabled={disabled}
                key={String(option.value)}
                value={String(option.value)}
                control={<IgRadio disabled={disabled} size="small" />}
                label={
                  <IgTypography variant={"body1"}>{option.label}</IgTypography>
                }
              />
            ))}
          </RadioGroup>
        )}
      </Grid>
    </Grid>
  );
};
